export default {
  Whisper: "Whisper",
  HiddenMode: "Gizli Mod",
  Camera: "Kamera",
  Microphone: "Mikrofon",
  Join: "Katıl",
  ValidatingToken: "Token Doğrulanıyor",
  WhisperSettings: "Whisper Ayarları",
  SomeoneElseAlreadyObeserving: "Başka biri zaten aramayı izliyor!",
  Copy: "Kopyala",
  Copied: "Kopyalandı!",
  CopyFailed: "Kopyalama Başarısız!",
  SupervisorLink: "Supervizör Linki:",
  Close: "Kapat",
  LocalURLBaseNotSet: "LOCAL_URL_BASE admin panel konfigürasyonunda ayarlanmamış.",
};
